import EnhancedCurrency from './EnhancedCurrency';
export default EnhancedCurrency;
//# sourceMappingURL=index.js.map
